import { docsConsoleSharingIntro, docsConsoleSharingTitle } from 'Clepit/translations';
import type { SupportedLanguage } from '@bomdisoft/translations';
import type { EditorData } from '@clepit/core';

/** Derived from `app/[lang]/pages/[id]/share-popover.tsx`, `state/publishing`,
 * `app/[lang]/p/[slug]/page.tsx`, and `app/[lang]/share/[token]/page.tsx`. */
export const buildConsoleSharing = (language: SupportedLanguage): EditorData => ({
  blocks: [
    { data: { html: docsConsoleSharingTitle[language], level: 'h1' as const }, type: 'header' },
    { data: { html: docsConsoleSharingIntro[language] }, type: 'paragraph' },

    { data: { alt: 'The Share popover on a published document', caption: 'The Share popover: the publish switch, the public URL, an active share link.', url: '/images/docs/console/sharing/screen-light.png' }, type: 'image' },
    { data: { alt: 'The Share popover on a published document, dark theme', caption: 'The Share popover: the publish switch, the public URL, an active share link.', url: '/images/docs/console/sharing/screen-dark.png' }, type: 'image' },

    { data: { html: 'Publishing to the web', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'The Share popover leads with the publish switch. Publishing gives the document a public page served on clepit.space under its slug, with the SEO title, description, and image the document menu holds; unpublishing takes it back down. The console shows the public URL with a copy button, and its own /p route renders the published page as the author sees it, inside the console session. Publishing needs a connection: offline, the switch stays where it is rather than pretending.',
      },
      type: 'paragraph',
    },

    { data: { html: 'Share links', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'A share link is a token URL for a document that is not public: create one from the same popover, send it, and revoke it when it should stop working. Active links are listed with their revoke buttons, and the popover says so when the link quota is reached rather than failing quietly.',
      },
      type: 'paragraph',
    },

    { data: { html: 'Export', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'The document menu exports the document as HTML or Markdown, drawn from the same block JSON the editor writes, so what you download matches what renders.',
      },
      type: 'paragraph',
    },

    { data: { html: 'Where this meets the docs', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'A published page is drawn with the same server renderer the packages expose: <a href="../embedding">rendering and embedding</a> describes the pipeline, and the <a href="../api">API reference</a> lists the functions behind it.',
      },
      type: 'paragraph',
    },
  ],
  time: 1_745_000_000_000,
  version: '1.0.0',
});
